var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('EpbBadge',{class:[_vm.baseClass, `${_vm.baseClass}--state-${_vm.state}`],attrs:{"color":"transparent","tooltip":_vm.tooltip}},[_c('span',{staticClass:"eicon",class:[`${_vm.baseClass}__icon`]},[_vm._v("\n    "+_vm._s(_vm.icon)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }